import { withInstall } from '@antdv/utils';
import ADrawer from './src/Drawer';

export const Drawer = withInstall(ADrawer);

export default Drawer;

export * from './src/interface';
export * from './src/props';
